<script>
    import FreelanceProjects from "../projects/FreelanceProjects.svelte";
    import AppHead from "../projects/AppHead.svelte";
    import SeeDetails from "../projects/SeeDetails.svelte";
    import Gallery from "../components/Gallery.svelte";
    import { ddwItems, puzzleItems } from "../projects/projects-data";
</script>

<FreelanceProjects hidefooter />

<AppHead
    name="Daily Jigsaw Puzzle"
    icon="images/app_icon_puzzle.png"
    detail="Complex parts: modular puzzle engine, smooth animations, subscription monetization" />
<Gallery items={puzzleItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/daily-jigsaw-puzzles/id1450295584" />

<AppHead
    name="Daily Decision Wheel"
    icon="images/app_icon_ddw.png"
    detail="Complex parts: 60 fps spin + particle effects, share wheel with other users via link" />
<Gallery items={ddwItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/daily-decision-wheel/id1434195334"
    playStoreLink="https://play.google.com/store/apps/details?id=ru.epicapp.wheel&pcampaignid=epicapp-site" />

<div style="height:30px;"/>

<div style="text-align:center;">
    <h2>
        My Upwork account: <a href="https://www.upwork.com/fl/vladimirroganov" target="__blank">vladimirroganov</a>
    </h2>
</div>

<div style="height:90px;"/>